module.exports = __webpack_public_path__ + "static/media/dots.5db5b572.svg";